var map = {
	"./works_1.webp": 3508,
	"./works_10.webp": 5908,
	"./works_11.webp": 7767,
	"./works_12.webp": 8518,
	"./works_13.webp": 3249,
	"./works_14.webp": 7704,
	"./works_15.webp": 6875,
	"./works_16.webp": 1002,
	"./works_17.webp": 2101,
	"./works_18.webp": 892,
	"./works_19.webp": 7983,
	"./works_2.webp": 3873,
	"./works_20.webp": 4655,
	"./works_21.webp": 3788,
	"./works_22.webp": 4457,
	"./works_23.webp": 5358,
	"./works_24.webp": 8899,
	"./works_25.webp": 3136,
	"./works_26.webp": 5965,
	"./works_27.webp": 4626,
	"./works_28.webp": 2919,
	"./works_29.webp": 9908,
	"./works_3.webp": 3846,
	"./works_30.webp": 6714,
	"./works_31.webp": 885,
	"./works_32.webp": 712,
	"./works_33.webp": 9083,
	"./works_34.webp": 7238,
	"./works_35.webp": 3617,
	"./works_36.webp": 6900,
	"./works_37.webp": 7911,
	"./works_38.webp": 7762,
	"./works_39.webp": 2477,
	"./works_4.webp": 5691,
	"./works_40.webp": 925,
	"./works_41.webp": 7362,
	"./works_42.webp": 2707,
	"./works_43.webp": 8624,
	"./works_44.webp": 2697,
	"./works_45.webp": 2974,
	"./works_46.webp": 6319,
	"./works_47.webp": 4732,
	"./works_48.webp": 3013,
	"./works_49.webp": 8986,
	"./works_5.webp": 968,
	"./works_50.webp": 6704,
	"./works_6.webp": 7493,
	"./works_7.webp": 3322,
	"./works_8.webp": 3375,
	"./works_9.webp": 8492
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5551;